import { useState } from "react";
import { Image, Modal, Typography } from "antd";
import { SoundOutlined } from "@ant-design/icons";

const ContentModal = ({ content }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Helper function to render specific media types
  const renderMediaItem = (item, index) => {
    switch (item.type) {
      case "image":
        return (
          <div key={index} style={styles.mediaWrapper}>
            <Image
              width="100%"
              style={{ maxHeight: "600px", objectFit: "contain" }}
              src={item?.link}
              alt={`media-${index}`}
            />
          </div>
        );

      case "video":
        return (
          <div key={index} style={styles.mediaWrapper}>
            <video
              width="100%"
              height="auto"
              controls
              style={{
                maxHeight: "600px",
                borderRadius: "8px",
                backgroundColor: "#000",
              }}
              // Use the thumbnail prop if available as the poster image
              poster={item?.thumbnail || ""}
            >
              <source src={item?.link} />
              Your browser does not support the video tag.
            </video>
          </div>
        );

      case "audio":
        return (
          <div key={index} style={styles.audioCard}>
            <div style={styles.audioIconWrapper}>
              <SoundOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
            </div>
            <div style={{ flex: 1 }}>
              {/* Optional: Display a label or generic text since audio has no visual */}
              <Typography.Text
                strong
                style={{ display: "block", marginBottom: "5px" }}
              >
                Audio Clip {index + 1}
              </Typography.Text>
              <audio controls style={{ width: "100%", height: "40px" }}>
                <source src={item?.link} />
                Your browser does not support the audio element.
              </audio>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <p style={{ fontWeight: "bold", cursor: "pointer" }} onClick={showModal}>
        View
      </p>

      <Modal
        className="customModal"
        style={{ top: 20 }}
        width={800}
        title="Post Media"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null} // Optional: hide footer if you only want to view content
        destroyOnClose={true} // Kills media when closed
      >
        <div style={styles.container}>
          {content && content.length > 0 ? (
            content.map((item, i) => renderMediaItem(item, i))
          ) : (
            <p>No content available</p>
          )}
        </div>
      </Modal>
    </div>
  );
};

// Internal styles object for cleaner JSX
const styles = {
  container: {
    display: "flex",
    flexDirection: "column", // Stack items vertically for better mobile/desktop view
    alignItems: "center",
    gap: "20px",
    padding: "10px",
  },
  mediaWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#f5f5f5", // Subtle background for images/video containers
    borderRadius: "8px",
    overflow: "hidden",
  },
  audioCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "15px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  audioIconWrapper: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "#e6f7ff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "15px",
  },
};

export default ContentModal;
